enum PackageType {
    Process = 0,
    ProcessLibrary = 1,
    ProcessTemplate = 2
}

const PackageTypeValue = {
    GetText: (typeNumber: number) => {
        const type = PackageType[typeNumber];
        if (type) {
            return type.valueOf()
        }
        return ""
    }
}

export default PackageTypeValue